const state = {
  routeList: [],
  originRouteFrom:{
    path:'',
    query:{}
  }
  // token:''
}

const mutations = {
  SET_ROUTE_LIST (state, info) {
    state.routeList = info
  },
  SET_ORIGIN_ROUTE (state, info) {
    state.originRouteFrom = info
  },
}

const actions = {
  setRouteList({commit, state},_data){
    commit("SET_ROUTE_LIST",_data)
  },
  setOriginRoute({commit, state},_data){
    commit("SET_ORIGIN_ROUTE",_data)
  },
}


export default {
  // namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/routes.js